import styled from "styled-components"
import { CANVAS_WIDTH } from "../hooks/useVendingCartDesigner"

export const Wrapper = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;

  .canvas-container {
    max-width: ${CANVAS_WIDTH}px;
    width: 100% !important;
    margin: 0 auto !important;
  }
`

export const Footer = styled.div`
  margin-top: 20px;
`

export const NextButton = styled.button`
  outline: none;
  background-color: transparent;
  line-height: 34px;
  padding: 6px 12px;
  border: 1px solid black;
  border-radius: 6px;
  min-width: 140px;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const Title = styled.h2`
  font-family: "Open Sans Condensed";
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  line-height: 29px;
  color: #000000;
`
